import React, { useState, useCallback, useEffect } from "react";
import SettingsService from '@/services/SettingsService'

export default function useSettings() {

  // Data State
  const [settings, setSettings] = useState([]);
  
  // UI State
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
    
  const loadSettings = useCallback(async () => {
    // console.log("TCL -> useSettings -> loadSettings")
    setLoading(true);
    
    setError(null);

    const { data: settings, error } = await SettingsService.getSystem()
    // console.log("TCL -> useSettings -> settings, error:", settings, error)

    if (error) { console.error("Failed to load settings:", error); setError(error); setSettings([]); } 
    else { setSettings(settings); }
    
    setLoading(false);
  }, []);


  const updateSettings = async (newSettings) => {
    setSaving(true)
    const { success, error } = await SettingsService.setSystem(newSettings)
    if (error) {
      console.error("Failed to save system settings:", error)
      setSaving(false)
      return
    }
    if (success) {
      setSettings(newSettings)
      setSuccess("Settings saved successfully")
      setSaving(false)
    }
  }

  const clearError = useCallback(() => { setError(null);}, []);
  const clearSuccess = useCallback(() => { setSuccess(null);}, []);
  useEffect(() => { loadSettings();}, []);

  return {
    settings, loading, saving,
    error, success, clearError, clearSuccess,
    loadSettings, updateSettings
  };
}